"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BankRepository {
    fetcherAmplify;
    constructor(fetcherAmplify) {
        this.fetcherAmplify = fetcherAmplify;
    }
    async listBanks() {
        return this.fetcherAmplify.get('/v1/banks');
    }
}
exports.default = BankRepository;
//# sourceMappingURL=BankRepositoryImpl.js.map